import { Message, useMessageContext } from "@/components/ui/message/message"
import { MessageText } from "@/components/ui/message/message-text"
import { detectType } from "@/components/ui/message/message-file"
import { useMessageData } from "@/components/chat/useMessageData"
import { useContext } from "react"
import { ChatHistoryContext } from "@/contexts/ChatHistoryContext"
import { MessageBody } from "@/components/ui/message/message-body"

const MessageReplyFallback = () => {
  const { message } = useMessageContext()
  return <MessageText content={message.replyMessage?.body} />
}

const MessageReply = () => {
  const { replyMessage } = useMessageContext()
  const type = detectType(replyMessage?.fileName)
  const messageData = useMessageData(replyMessage!)
  const { jumpAndHighlightMessage } = useContext(ChatHistoryContext)

  return (
    <div className="relative">
      <div
        onClick={() => jumpAndHighlightMessage(replyMessage!.id)}
        className="my-4 bg-gray-200/50 pl-4 before:absolute before:left-0 before:top-0 before:h-full before:w-[3px] before:rounded-l-md before:bg-active-chat dark:bg-gray-800"
      >
        <Message.Header
          author={messageData.authorName}
          showTimestamp={false}
          className="mb-2"
        />
        <MessageBody
          type={type}
          reply={true}
          content={messageData.displayBody}
          contentOffset={messageData.displayBodyOffset}
        />
      </div>
    </div>
  )
}

export { MessageReply, MessageReplyFallback }
